import { RootState } from "../StoreHooks";

export const getWeatherDisruptionState = (state: RootState) => {
  const { weatherDisruption } = state.weatherDisruption || {};
  return weatherDisruption;
};
